<template>
  <div>
    <logged-in-header />
    <certificate-bar />
    <lockers-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import certificateBar from "../components/common/CertificateBar.vue";
import lockersPanel from "../components/dashboard/LockersPanel.vue";

export default {
  components: {
    loggedInHeader,
    certificateBar,
    lockersPanel
  }
};
</script>
